<template>
    <div class="tab-pane fade show active text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="tab-pane fade show active text-center" v-else-if="players.length == 0">
        <p>No player found.</p>
    </div>
    <div class="tab-pane fade show active" v-else>
        <div class="table-responsive">
            <div class="match-table info">
                <div class="thead">
                    <div class="table-row align-items-end">
                        <div class="th">player name</div>
                        <div class="th">Batting Style</div>
                    </div>
                </div>
                <div class="table-body">
                    <div class="tbody">
                        <div class="table-row" v-for="player in players" :key="player.id">
                            <!-- <router-link :to="{ name: 'playerDetail.info', params:  { player: player.slug} }"> -->
                            <div class="td">
                                <router-link :to="{ name: 'playerDetail.info', params:  { player: player.slug} }">
                                    <span class="title d-none d-md-block">{{ player.name }}</span>
                                    <span class="title d-md-none">{{ player.short_name }}</span>
                                </router-link>
                            </div>
                            <div class="td"><span class="title">{{ player.batting_style != 'null' ? player.batting_style : '-' }}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'teamPlayers',
        data() {
            return {
                players: []
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
        },
        methods: {
            main() {
                return this.$axios.get(this.$TEAM_PLAYERS_API.replace(':tournament', this.$route.params.tournament).replace(':team', this.$route.params.team))
                        .then(response => {
                            this.is_data_ready = true
                            this.players = response.data.result.players || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            }
        }
    }
</script>

